module.exports = require("timers");


//////////////////
// WEBPACK FOOTER
// external "timers"
// module id = 386
// module chunks = 0